import * as React from 'react';
import { connect } from 'react-redux';

import { GlobalPrivateState } from 'src/api';

import './../UserList/UserList.scss';
import './PostcodeList.scss';
import { UserModel } from 'franke-trough-dependencies';
import { filterUsersBySword } from '../utils';
import PostcodeListItemManage from './PostcodeListItemManage';
import { UsersDispatcher } from 'src/app/Container';
 
export interface PostcodeListProps {
  usersAdminList: GlobalPrivateState['users'];
  queryState: GlobalPrivateState['queryState'];
  dispatch: any;
}

export class PostcodeListPartial extends React.Component<PostcodeListProps, any> {
  constructor(props: PostcodeListProps) {
    super(props);

    this.state = {
      users: filterUsersBySword(this.users, this.sword)
    }
  }

  componentDidUpdate(prevState: PostcodeListProps) {
    const prevUsers = prevState.usersAdminList.result;
    const prevSearch = prevState.queryState.search;
    const users = this.props.usersAdminList.result;
    const search = this.props.queryState.search;

    const searchChanged = ((prevSearch && prevSearch.indexOf('sword') > -1) || (search && search.indexOf('sword') > -1)) && prevSearch !== search;
    const usersChanged = users && prevUsers !== users;

    if (searchChanged || usersChanged) {
      this.setState({
        users: filterUsersBySword(this.users, this.sword)
      });
    }
  }

  public render() {
    const users = this.state.users;

    return (
      <div className="partial-postcode-list">
        <UsersDispatcher />
        {users && users.length > 0 && (
          <ol className="user-list">
            <li className="user-list__header">
              <span className="user-list__fullname">FAR Internal</span>
              <span className="user-list__postcode">Postcode</span>
              <span className="user-list__city">City</span>
              <span className="user-list__country">Country</span>
              <span className="user-list__email">Email</span>
              <span className="user-list__postcodes">Postcode Areas</span>
              <span className="user-list__assigned">Assigned External</span>
              <span className="user-list__action"></span>
            </li>
            {users.map((user: UserModel) => (
              <PostcodeListItemManage 
                key={user.id} 
                user={user} />
            ))}
          </ol>
        )}
        {this.props.usersAdminList.result && users && users.length === 0 && (
          <h3>No users found...</h3>
        )}
      </div>
    );
  }

  get users() {
    const usersAdminList = this.props.usersAdminList.result;
    const users = usersAdminList && usersAdminList.users;
    const validUsers = users && users.filter((user) => user.roles && user.roles.find(role => role.name === 'internal' || role.name === 'salesrep'));
    return validUsers;
  }

  get sword() {
    const sword = this.props.queryState.params.sword;
    return sword;
  }
}

export const PostcodeList = connect((state: GlobalPrivateState) => ({
  usersAdminList: state.users,
  queryState: state.queryState
}))(PostcodeListPartial);

export default PostcodeList;
